import {AfterViewInit, Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import {DashAlert} from '../../../domain/alerts/dash-alert.model';
import {Router} from '@angular/router';

@Component({
  selector: 'cm-widget-alerts-table',
  template: `
    <div class="table-scroll-wrapper">
      <mat-table #table [dataSource]="dataSource"
                 matSort matSortActive="adUnitName"
                 matSortDirection="asc"
                 class="cm-table-content widget-alerts-table">
        <ng-container matColumnDef="alertType">
          <mat-header-cell mat-sort-header *matHeaderCellDef>Type</mat-header-cell>
          <mat-cell *matCellDef="let row">{{row.alertType }}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="adUnitsNumber">
          <mat-header-cell mat-sort-header *matHeaderCellDef>Num of alerts</mat-header-cell>
          <mat-cell *matCellDef="let row">
            <div class="alert-table-number">{{ row.adUnitsNumber }}</div>
          </mat-cell>
        </ng-container>

        <mat-header-row hidden *matHeaderRowDef="['alertType','adUnitsNumber']"></mat-header-row>
        <mat-row class="link" *matRowDef="let row; columns: ['alertType','adUnitsNumber']"
                 (click)="onRowClick(row)"></mat-row>
      </mat-table>
    </div>
  `,
  styles: [`
    .mat-table {
      /*min-width: 700px;*/
    }

    .widget-alerts-table .mat-row {
      min-height: 60px;
    }

    .alert-table-number {
      display: flex;
      align-items: center;
      justify-content: center;
      flex: 0 0 36px;
      height: 36px;
      color: #FF5B5A;
      font-size: 16px;
      letter-spacing: -1px;
      font-weight: bold;
      border: 1px solid #E1E6EC;
      border-radius: 50%;
    }

    .mat-column-adUnitsNumber {
      flex: 0 0 65px;
      text-align: right;
    }

  `],
  host: {'class': 'cm-widget-alerts-table'}
})
export class WidgetAlertsTableComponent implements AfterViewInit, OnInit {

  @Input() paginator: MatPaginator;
  @ViewChild(MatSort, {static: true}) sort: MatSort;

  @Input('data')
  set data(data: DashAlert[]) {
    this.dataSource.data = data;
  }

  @Output()
  rowClick = new EventEmitter<DashAlert>();

  dataSource = new MatTableDataSource<DashAlert>();

  constructor(private router: Router) {
  }

  onRowClick(row: DashAlert) {
    this.rowClick.emit(row);
  }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }
}

